/**
 * Static content for zeroto10.dev.
 * All copy lives here — populated by build prompts 3-12.
 */

export const siteContent = {
  brand: {
    name: "Zero to Ten",
    tagline: "I take your idea from zero to ten.",
    logoText: "0→10",
    ctaText: "START BUILDING →",
    domain: "zeroto10.dev",
  },
  contact: {
    // Booking link. Swap to Cal.com / SavvyCal when set up.
    // Current fallback: opens email client pre-filled so no CTA dead-ends.
    calLink:
      "mailto:rick@zeroto10.dev?subject=Intro%20call%20%E2%80%94%20Zero%20to%20Ten&body=Hi%20Rick%2C%0A%0AI%20saw%20your%20site%20and%20want%20to%20talk%20about%3A%0A%0A%5Bwhat%20you%27re%20building%20or%20trying%20to%20fix%5D%0A%0AStage%2Ffunding%3A%0ATimeframe%3A%0A%0AThanks%2C%0A%5Bname%5D",
    email: "rick@zeroto10.dev",
    linkedin: "https://www.linkedin.com/in/rickdeaconx",
    twitter: "https://x.com/rickdeaconx",
    location: "Cleveland, OH",
  },
  trustBar: {
    // "Technology adopted by / Founders I've built with"
    label: "TECHNOLOGY ADOPTED BY",
    logos: ["Coinbase", "Uber", "Gemini", "Hagerty", "Y Combinator"],
  },
} as const;
